const initialState = {
    calls: [],
}

export default function(state = initialState, action) {
    switch(action.type) {
        case "ADD_INCOMING_CALL":
            // action.payload.data['answered'] = 0;
            return {
                ...state,
                calls: [ ...state.calls, action.payload]
            }
        case "REMOVE_INCOMING_CALL":
            return {
                ...state,
                calls: state.calls.filter(item => item.data.id !== action.payload.data.id),
            }
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/incomingCallsList.js